/* 
** Theme Utils
*/
export const applyThemeColors = (themeColors: Record<string, string>) => {

  const supportedKeys: Record<string, string> = {
    primary_color: "--primary",
    primary_color_light: "--primary-light",
    primary_color_dark: "--primary-dark",
    secondary_color: "--secondary",
    secondary_color_light: "--secondary-light",
    logo_uri: "--logo-uri",
    logo_emblem_uri: "--logo-emblem-uri",
  };

  let cssContent = ':root {\n';
  Object.entries(themeColors).forEach(([key, value]) => {
    const cssVar = supportedKeys[key];
    if (cssVar && value && value.trim() !== "") {
      document.documentElement.style.setProperty(cssVar, value);
    }
  });
};